import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import withStyles from "components/with-styles";
import styles from "./styles/thumbnail.css.js";
import AssetWithFallback from "./asset-with-fallback";

const Thumbnail = ({
  classes,
  className,
  width,
  height,
  path,
  sizeX,
  sizeY,
  fullwidth,
  maxWidth,
  center,
  ...props
}) => {
  if (fullwidth) {
    return (
      <AssetWithFallback
        className={cn(className, { [classes.centeredImage]: center })}
        width="100%"
        src={path}
        {...props}
      />
    );
  } else if (sizeX && sizeY) {
    return (
      <AssetWithFallback
        className={cn(className, { [classes.centeredImage]: center })}
        width={width}
        height={height ? height : (width / sizeX) * sizeY}
        src={path}
        {...props}
      />
    );
  } else {
    return (
      <AssetWithFallback width={width} className={cn({ [classes.centeredImage]: center })} src={path} {...props} />
    );
  }
};

Thumbnail.propTypes = {
  /**
   * Width of the asset
   **/
  width: PropTypes.number,
  /**
   * Max width of the asset
   **/
  maxWidth: PropTypes.number,
  /**
   * Format of asset [png, apng, mp4]
   **/
  format: PropTypes.string,
  /**
   * Url of the image
   **/
  path: PropTypes.string,
  /**
   * Size in X (px)
   **/
  sizeX: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Size in Y (px)
   **/
  sizeY: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Sets the with to 100%
   **/
  fullwidth: PropTypes.bool,
  /**
   * Shows the thumbnail centered
   **/
  center: PropTypes.bool,
  /**
   * Shows the thumbnail if there is a video
   **/
  preview: PropTypes.bool,
};

export default withStyles(styles)(Thumbnail);
